import sharedMutations from '@/campaign-form-shared/store/mutations'

export default {
  ...sharedMutations,
  clearRequestHelpPrompt(state) {
    state.fieldToShowRequestHelpPrompt = null
  },

  setCurrentField(state, currentField) {
    state.currentField = currentField
  },

  setHelpRequested(state) {
    state.helpRequested = true
  },

  setPetitionStartCreated(state, value) {
    state.petitionStartCreated = value
  },

  setPetitionStartToken(state, token) {
    state.petitionStartToken = token
  },

  setPetitionStartUrl(state, petitionStartUrl) {
    state.petitionStartUrl = petitionStartUrl
    history.pushState({ token: state.petitionStartToken }, '', state.petitionStartUrl)
  },

  setSubmitInProgress(state, value) {
    state.submitInProgress = value
  },

  setNonRecoverableErrorOnSignup(state, errorMessage) {
    state.nonRecoverableErrorOnSignup = errorMessage
  },

  setUpdateUrl(state, updateUrl) {
    state.updateUrl = updateUrl
  },

  setRequestHelpUrl(state, requestHelpUrl) {
    state.requestHelpUrl = requestHelpUrl
  },

  setRequestHelpPromptOnField(state, field) {
    state.fieldToShowRequestHelpPrompt = field
  },

  setValue(state, {field, value}) {
    state.values[field] = value

    // Clear error on field if there was one
    if (state.validationErrors[field]) {
      let clonedValidationErrors = Object.assign({}, state.validationErrors)
      delete clonedValidationErrors[field]

      state.validationErrors = clonedValidationErrors
    }
  }
}
